<template>
    <input
        :class="cssClass"
        :type="type"
        :id="id"
        :value="value"
        @input="onInput"
        @blur="onBlur"
        @keyup="(event) => this.$emit('keyup', event)"
        @keypress="(event) => this.$emit('keypress', event)"
    >
</template>

<script>
export default {

    name: 'InputText',

    props: {
        value: '',
        id: {
            type: String,
            default: () => { return 'input-' + Math.floor(Math.random() * 1000000000); }
        },
        type: {
            type: String,
            default: 'text',
        },
        isBootstrap: {
            type: Boolean,
            default: false
        },
        error: Array,
        isBulma: {
            type: Boolean,
            default: true
        },
        inputSize: {
            type: String,
            default: ''
        },
    },

    computed: {
        cssClass() {
            let classes = []
            if (this.isBootstrap) {
                classes.push('form-control')
                if (this.inputSize) {
                    classes.push('input-' + this.inputSize)
                }
            }
            if (this.isBulma) {
                classes.push('input')
                if (this.error) {
                    classes.push('is-danger')
                }
                if (this.inputSize) {
                    classes.push('is-' + this.inputSize)
                }
            }

            return classes.join(' ')
        }
    },

    methods: {
        onInput(event) {
            this.$emit('input', event.target.value)
        },

        onBlur(event) {
            this.$emit('blur', event.target.value)
        },
    },
}
</script>
